import { StyledCheckboxTreeComponent } from './styles';
import React from 'react';
import { Tree } from 'antd';
import type { DataNode, TreeProps } from 'antd/es/tree';

interface CheckboxTreeProps extends Pick<TreeProps, 'onClick' | 'onExpand' | 'expandedKeys'> {
  items: DataNode[];
  showIcon?: boolean;
  onCheck?: TreeProps['onCheck'];
  defaultExpandedKeys: string[];
  checkedKeys: string[];
}

const onCheckDefault: TreeProps['onCheck'] = (checkedKeys, info) => {
  console.log('onCheck', checkedKeys, info);
};

const CheckboxTree = ({
  items,
  showIcon,
  onCheck = onCheckDefault,
  defaultExpandedKeys,
  checkedKeys = [],
  onClick,
  onExpand,
  expandedKeys,
}: CheckboxTreeProps) => {
  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
  };

  return (
    <StyledCheckboxTreeComponent>
      <Tree
        checkable
        onSelect={onSelect}
        onCheck={onCheck}
        treeData={items}
        showIcon={showIcon}
        defaultExpandedKeys={defaultExpandedKeys}
        checkedKeys={checkedKeys}
        onClick={onClick}
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        selectable={false}
      />
    </StyledCheckboxTreeComponent>
  );
};

export default CheckboxTree;
